module.exports = __webpack_public_path__ + "img/1-(8).10da3a11.jpg";